// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"e68de8d5","315":"b88e5f8a","409":"036d71c0","631":"d81ffb8e","760":"bf87a6a3","771":"232afb61","774":"2554d356"}[chunkId] + ".chunk.js";
};